'use strict';

import { callTurnstile } from 'shared/js/turnstileWidget';

function validEmail(value) {
    // eslint-disable-next-line no-useless-escape
    var pattern = /^[a-zA-Z0-9]*([\w+-]+\.)*[\w+-]+@[a-zA-Z0-9]([\w-]+\.)*[a-zA-Z]{2,6}$/;
    return pattern.test(String(value).toLowerCase());
}

function findEventSignupError(form) {
    var email = form.find('[name="email"]');
    var emailValue = $.trim(email.val());
    if (!validEmail(emailValue)) {
        return { name: 'email', message: email.data('missing-error') };
    }
    if (form.find('[name="signupType"]').val() !== 'member') {
        return null;
    }

    var requiredNames = ['firstName', 'lastName', 'mobilePhone'];
    var i;
    for (i = 0; i < requiredNames.length; i += 1) {
        var fieldName = requiredNames[i];
        var field = form.find('[name="' + fieldName + '"]');
        var value = $.trim(field.val());
        if (!value) {
            return { name: fieldName, message: field.data('missing-error') };
        }
        if (fieldName === 'mobilePhone') {
            var digits = value.replace(/\D/g, '');
            if (!/^[+\d\s().-]+$/.test(value) || digits.length < 8 || digits.length > 15) {
                return { name: 'mobilePhone', message: field.data('invalid-error') };
            }
        }
    }

    var terms = form.find('[name="memberTerms"]');
    if (terms.length && !terms.is(':checked')) {
        return { name: 'memberTerms', message: terms.data('missing-error') };
    }
    return null;
}

function showEventSignupFieldError(form, fieldName, message) {
    var field = form.find('[name="' + fieldName + '"]');
    var errorId = field.attr('aria-describedby');
    field.attr('aria-invalid', 'true');
    if (errorId) {
        form.find('[id="' + errorId + '"]').text(message).removeClass('hidden');
    }
    if (field.length) {
        field.trigger('focus');
    }
}

module.exports = function () {
    $('.eventSignupForm').on('submit', function (e) {
        e.preventDefault();
        var form = $(this);
        var submitButton = form.find('.event-signup-submit');
        if (submitButton.prop('disabled')) {
            return false;
        }
        var successMessage = form.find('.event-signup-success');
        var formError = form.find('.event-signup-form-error');
        var serverError = form.data('server-error');
        var fieldError;

        form.find('.event-signup-field-error').addClass('hidden').text('');
        form.find('[aria-invalid]').attr('aria-invalid', 'false');
        successMessage.addClass('hidden');
        formError.addClass('hidden').text('');

        fieldError = findEventSignupError(form);
        if (fieldError) {
            showEventSignupFieldError(form, fieldError.name, fieldError.message);
            return false;
        }

        var formEl = this;
        var formData = form.serialize();

        var submitSignup = function (turnstileResponse) {
            var ajaxData = formData.replace(/&?cf-turnstile-response=[^&]*/g, '').replace(/^&/, '');
            if (turnstileResponse) {
                ajaxData += (ajaxData ? '&' : '') + 'cf-turnstile-response=' + encodeURIComponent(turnstileResponse);
            }
            $.ajax({
                url: form.attr('action'),
                method: 'POST',
                data: ajaxData,
                success: function (data) {
                    if (!data || data.success !== true) {
                        formError.text(serverError).removeClass('hidden');
                        return;
                    }
                    if (data.alreadySubscribed) {
                        formError.text(data.alreadySubscribedMessage).removeClass('hidden');
                        return;
                    }
                    successMessage.removeClass('hidden');
                    form.find('.event-signup-field').val('');
                    form.find('[name="memberTerms"]').prop('checked', false);
                    successMessage.trigger('focus');
                },
                error: function (xhr) {
                    var data = xhr.responseJSON || {};
                    if (data.field) {
                        showEventSignupFieldError(form, data.field, data.errorMessage || serverError);
                    } else {
                        formError.text(data.errorMessage || serverError).removeClass('hidden');
                    }
                },
                complete: function () {
                    submitButton.prop('disabled', false);
                }
            });
        };

        var showTurnstileFailure = function () {
            submitButton.prop('disabled', false);
            formError.text(serverError).removeClass('hidden');
        };

        submitButton.prop('disabled', true);
        try {
            callTurnstile(submitSignup, formEl.querySelector('.event-signup-turnstile'), showTurnstileFailure);
        } catch (err) {
            showTurnstileFailure();
        }
        return true;
    });
};
